// domain/komisi — perhitungan komisi teknisi (murni, testable). Satu sumber dipakai
// Laporan Teknisi/Komisi + menu Income. Basis = kas DIAKUI (omzet/profit verified) — bukan piutang.
export interface KomisiScheme { type: string; val: number }
export interface EmpKomisi { nama: string; komisi_type?: string | null; komisi_val?: number | null }

/** Skema komisi teknisi: pakai skema per-karyawan bila `komisi_type` diisi (val 0 = nol), else skema GLOBAL. */
export function resolveScheme(tek: string, emps: EmpKomisi[], global: KomisiScheme): KomisiScheme {
  const e = emps.find((x) => x.nama === tek);
  if (e?.komisi_type) return { type: e.komisi_type, val: e.komisi_val ?? 0 };
  return { type: global.type || 'profit', val: global.val ?? 10 };
}

/** Tiket layak KOMISI = Sudah Diambil & DIVERIFIKASI Finance & ada teknisi (Batch 60 verified-gate).
 *  Satu predikat dipakai Laporan Komisi + menu Income → basis komisi tak drift. */
export function isKomisiEligible(t: { status: string; verified?: boolean | null; teknisi?: string | null }): boolean {
  return t.status === 'Sudah Diambil' && !!t.verified && !!t.teknisi;
}

/** Nominal komisi: 'omzet' = %×omzet · 'profit' = %×profit(omzet−HPP) · 'nominal' = val×unit(verified). */
export function komisiFor(scheme: KomisiScheme, omzet: number, profit: number, unit: number): number {
  if (!scheme.val) return 0;
  return scheme.type === 'omzet' ? omzet * scheme.val / 100
    : scheme.type === 'nominal' ? scheme.val * unit
    : profit * scheme.val / 100;
}
